


<script>
	let userObject=null;
	const userBase= window.userbase;
	
	let authPromise= userBase.init({appId: '4bef59b3-7749-417d-92aa-b69056492dab'}).then(({user}) => userObject = user)

	let username, password;
	
	var dateObj = new Date();
	var month = dateObj.getUTCMonth() + 1; //months from 1-12
	var day = dateObj.getUTCDate();
	var year = dateObj.getUTCFullYear();

	let newdate = day + "/" + month + "/" + year;
	

	const signIn = ()=> authPromise = userBase.signIn({username, password}).then(user => userObject = user);
	const signUp= () => authPromise= userBase.signUp({username, password}).then(user => userObject = user);
	const signOut = () => authPromise = userBase.signOut ().then (() => userObject = null);

	let postPromise;
	let posts = [], newPost, icerik;
	const databaseName ="posts";
	function changeHandler(items) {posts= items};
	$: if (userObject)  userBase.openDatabase({databaseName, changeHandler});


	function addPost (){
		userBase.insertItem({databaseName, item:{newPost,icerik, newdate} });
		newPost="";
		icerik="";
	}



	function deletePost(itemId) {
        postPromise = userbase.deleteItem({databaseName, itemId});
	}
	
</script>


<main>
	<h2>Kalk Yap</h2> {#if userObject}<button on:click={signOut} type="button" class="btn btn-secondary">Sign Out</button>{/if}
	<br>
	<h3>Yapman için her şeyi burada bulacaksın!</h3>
	{#await authPromise} loading...{:then _}
		{#if !userObject}
	<div class="signUpDiv">
	<form>
		<input id="username" bind:value="{username}" class="signUpInput" type="text" name="Ad Soyad" placeholder="Ad Soyad">
		<br>
		<input id="password" bind:value={password} class="signUpInput" type="password" name="sifre" placeholder="Sifre">
		<br>
		<button on:click={signUp} type="button" class="signUpBtn">Sign Up</button>
		<button on:click={signIn} type="button" class="signUpBtn">Sign In</button>

	</form>
	</div>
		{:else}
			<div class="card text-center yazi">
  				<div class="card-header">
  				  Hoş Geldin Sevgili {userObject.username} 
  				</div>
  				<div class="card-body">
    				<h5 class="card-title">Tarihe Bir Not Bırakma Zamanı</h5>
					
						
						
						
					
					<div style="margin-bottom:20px;" class="input-group">
					  <div class="input-group-prepend">
					    <span class="input-group-text">Başlık</span>
					  </div>
					  	
						<input  class="form-control" placeholder="Başlık" id="Baslik" type="text" bind:value={newPost}>
						
					</div>
					<div style="margin-bottom:20px;" class="input-group">
					  	<div class="input-group-prepend">
					  	  <span class="input-group-text">İçerik</span>
					  	</div>
					  	
						<textarea class="form-control"   id="icerik" bind:value={icerik} placeholder="İçerik"></textarea>
					</div>
    				
								
					
					<button style="width: -webkit-fill-available;" on:click={addPost} type="button" class="btn btn-primary">Not Ekle</button>
					
  				</div>
  				<div class="card-footer text-muted">
					
					<img src="https://img.icons8.com/fluent/48/000000/hand-with-pen.png" alt="write">
					<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="48" height="48" viewBox="0 0 172 172" style=" fill:#000000;"><defs><radialGradient cx="86" cy="86" r="73.79606" gradientUnits="userSpaceOnUse" id="color-1_119436_gr1"><stop offset="0" stop-color="#afeeff"></stop><stop offset="0.193" stop-color="#bbf1ff"></stop><stop offset="0.703" stop-color="#d7f8ff"></stop><stop offset="1" stop-color="#e1faff"></stop></radialGradient><linearGradient x1="34.9375" y1="86" x2="142.4375" y2="86" gradientUnits="userSpaceOnUse" id="color-2_119436_gr2"><stop offset="0" stop-color="#ffce76"></stop><stop offset="1" stop-color="#ffcca0"></stop></linearGradient><linearGradient x1="88.6875" y1="226.524" x2="88.6875" y2="56.53694" gradientUnits="userSpaceOnUse" id="color-3_119436_gr3"><stop offset="0" stop-color="#ff8b67"></stop><stop offset="0.847" stop-color="#ffa76a"></stop><stop offset="1" stop-color="#ffad6b"></stop><stop offset="1" stop-color="#ffad6b"></stop></linearGradient><linearGradient x1="43" y1="147.8125" x2="43" y2="-27.79681" gradientUnits="userSpaceOnUse" id="color-4_119436_gr4"><stop offset="0" stop-color="#ff8b67"></stop><stop offset="0.847" stop-color="#ffa76a"></stop><stop offset="1" stop-color="#ffad6b"></stop><stop offset="1" stop-color="#ffad6b"></stop></linearGradient><linearGradient x1="114.21875" y1="129.27681" x2="114.21875" y2="67.60406" gradientUnits="userSpaceOnUse" id="color-5_119436_gr5"><stop offset="0" stop-color="#ff8b67"></stop><stop offset="0.847" stop-color="#ffa76a"></stop><stop offset="1" stop-color="#ffad6b"></stop><stop offset="1" stop-color="#ffad6b"></stop></linearGradient><linearGradient x1="98.09375" y1="120.443" x2="98.09375" y2="85.99731" gradientUnits="userSpaceOnUse" id="color-6_119436_gr6"><stop offset="0" stop-color="#ff8b67"></stop><stop offset="0.847" stop-color="#ffa76a"></stop><stop offset="1" stop-color="#ffad6b"></stop><stop offset="1" stop-color="#ffad6b"></stop></linearGradient><linearGradient x1="77.9375" y1="88.6875" x2="77.9375" y2="10.75" gradientUnits="userSpaceOnUse" id="color-7_119436_gr7"><stop offset="0" stop-color="#ff634d"></stop><stop offset="0.204" stop-color="#fe6464"></stop><stop offset="0.521" stop-color="#fc6581"></stop><stop offset="0.794" stop-color="#fa6694"></stop><stop offset="0.989" stop-color="#fa669a"></stop><stop offset="1" stop-color="#fa669a"></stop></linearGradient></defs><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g><path d="M149.03263,122.73275c1.34375,2.41338 4.042,3.59319 6.80475,3.57975c4.70313,-0.0215 8.47369,3.98556 8.06788,8.76663c-0.35744,4.2355 -4.17638,7.35837 -8.428,7.35837h-26.47725v2.6875h-59.125h-21.5h-29.5625c-4.59562,0 -8.29362,-3.84581 -8.05175,-8.49519c0.22844,-4.36181 4.14144,-7.62981 8.50863,-7.62981h2.23063c3.26531,0 5.848,-2.91056 5.30244,-6.278c-0.43,-2.64181 -2.91325,-4.472 -5.59,-4.472h-13.14994c-4.59562,0 -8.29362,-3.84581 -8.05175,-8.49519c0.22844,-4.36181 4.14144,-7.62981 8.50863,-7.62981h17.01188c3.71144,0 6.71875,-3.00731 6.71875,-6.71875v0c0,-3.71144 -3.00731,-6.71875 -6.71875,-6.71875v0c-3.71144,0 -6.71875,-3.00731 -6.71875,-6.71875v0c0,-3.71144 3.00731,-6.71875 6.71875,-6.71875h22.84375v-18.8125h-20.15625c-5.36156,0 -9.67769,-4.48813 -9.39281,-9.9115c0.26606,-5.08744 4.83213,-8.901 9.92494,-8.901h19.62413v-10.75h64.5h16.125h22.03213c5.36156,0 9.67769,4.48813 9.39281,9.9115c-0.26606,5.08744 -4.83212,8.901 -9.92494,8.901h-6.71875c-5.36156,0 -9.67769,4.48813 -9.39281,9.9115c0.26606,5.08744 4.83212,8.901 9.92494,8.901h6.18662c4.77569,0 8.58388,4.15488 8.00338,9.04613c-0.48106,4.05544 -4.15488,6.91225 -8.2345,7.08156c-3.21694,0.13438 -5.70288,3.09869 -5.03638,6.46612c0.50525,2.54775 2.91056,4.28119 5.50669,4.28119h11.85456c5.36156,0 9.67769,4.48813 9.39281,9.9115c-0.26606,5.08744 -4.83212,8.901 -9.92494,8.901h-6.18662c-5.891,0 -10.30388,6.31562 -6.84238,12.54525zM6.71875,88.6875v0c3.71144,0 6.71875,-3.00731 6.71875,-6.71875v0c0,-3.71144 -3.00731,-6.71875 -6.71875,-6.71875v0c-3.71144,0 -6.71875,3.00731 -6.71875,6.71875v0c0,3.71144 3.00731,6.71875 6.71875,6.71875z" fill="url(#color-1_119436_gr1)"></path><path d="M134.375,155.875h-91.375c-4.45319,0 -8.0625,-3.60931 -8.0625,-8.0625v-123.625c0,-4.45319 3.60931,-8.0625 8.0625,-8.0625h91.375c4.45319,0 8.0625,3.60931 8.0625,8.0625v123.625c0,4.45319 -3.60931,8.0625 -8.0625,8.0625z" fill="url(#color-2_119436_gr2)"></path><path d="M134.375,139.75h-99.4375v-115.5625c0,-4.45319 3.60931,-8.0625 8.0625,-8.0625h91.375c4.45319,0 8.0625,3.60931 8.0625,8.0625v107.5c0,4.45319 -3.60931,8.0625 -8.0625,8.0625z" fill="url(#color-3_119436_gr3)"></path><path d="M51.0625,139.75h-8.0625c-4.45319,0 -8.0625,3.60931 -8.0625,8.0625v0v-123.625c0,-4.45319 3.60931,-8.0625 8.0625,-8.0625h8.0625z" fill="url(#color-4_119436_gr4)"></path><path d="M110.1875,106.15625v0c0,3.71144 3.00731,6.71875 6.71875,6.71875h5.375c3.71144,0 6.71875,3.00731 6.71875,6.71875v0c0,3.71144 -3.00731,6.71875 -6.71875,6.71875h-29.5625c-3.71144,0 -6.71875,3.00731 -6.71875,6.71875v0c0,3.71144 3.00731,6.71875 6.71875,6.71875h41.65625c4.45319,0 8.0625,-3.60931 8.0625,-8.0625v-32.25h-25.53125c-3.71144,0 -6.71875,3.00731 -6.71875,6.71875z" fill="url(#color-5_119436_gr5)"></path><path d="M98.09375,99.4375c-3.71066,0 -6.71875,3.00809 -6.71875,6.71875c0,3.71066 3.00809,6.71875 6.71875,6.71875c3.71066,0 6.71875,-3.00809 6.71875,-6.71875c0,-3.71066 -3.00809,-6.71875 -6.71875,-6.71875z" fill="url(#color-6_119436_gr6)"></path><path d="M87.58563,88.6875h-0.01613c-1.00513,0 -1.96994,-0.40044 -2.67944,-1.10994l-6.95256,-6.95256l-6.95256,6.95256c-0.7095,0.7095 -1.67431,1.10994 -2.67944,1.10994h-0.01612c-2.09356,0 -3.78938,-1.69581 -3.78938,-3.78938v-66.08562c0,-4.45319 3.60931,-8.0625 8.0625,-8.0625h10.75c4.45319,0 8.0625,3.60931 8.0625,8.0625v66.08562c0,2.09356 -1.69581,3.78938 -3.78937,3.78938z" fill="url(#color-7_119436_gr7)"></path></g></g></svg>
					<img src="https://img.icons8.com/emoji/48/000000/waving-hand-emoji.png" alt="hello">
  				</div>
			</div>
			
			
			
			

			

		{/if}
	{:catch error}Error! {error} {/await}



	
</main>

<div class="container blog">
  <div class="row">
  {#each posts as post}
    <div class="col-md">
			<div class="card" >
  			<div class="card-body">
    			<h5 class="card-title">{post.item.newPost}</h5>
    			<h6 class="card-subtitle mb-2 text-muted">{post.item.newdate}</h6>
				<p class="card-text">{post.item.icerik}</p>
    			
				
				<button style="background: none; border: none; width: 40px; height: 40px;}" on:click={() => deletePost(post.itemId)}>
					<img style="width: 32px; height: 32px;" src="https://img.icons8.com/color/48/000000/delete-forever.png" alt="delete">
				</button>
				
    			
  			</div>
		</div>
    </div>
	{/each}
    
    
  </div>
  
</div>


<style>

	.card{
		width: auto;
		margin-bottom: 20px;
		-webkit-box-shadow: 0px 0px 30px -18px rgba(56,2,2,0.89);
    	-moz-box-shadow: 0px 0px 30px -18px rgba(56,2,2,0.89);
	    box-shadow: 0px 12px 30px -25px rgba(56,2,2,0.89);
		}
	.blog{
		margin-top: 50px;
	}

	
	
	.signUpDiv{
		width: 100%;
		display: inline-block;
	}
	.signUpInput{
		width: 100%;
	}
	.signUpBtn{
		width: 100%;
	}
	main {
		text-align: center;
		padding: 1em;
		margin: 0 auto;
	}

	

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
		.signUpDiv{
			width: 40%;
		}
		.yazi{
			max-width: 50%;
			margin: auto;
		}

	}
</style>